import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {InternalColumn, InternalImpactPointService, InternalSection} from '@shared/components/internal-impact-point/internal-impact-point.service';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';
import {VehicleNature} from '../../../../claims/claims-commons/models/vehicle.model';

@Component({
    selector: 'amd-internal-impact-point-column',
    templateUrl: './internal-impact-point-column.component.html',
    styleUrls: ['./internal-impact-point-column.component.scss']
})
export class InternalImpactPointColumnComponent implements OnChanges {

    @Input() section: InternalSection;
    @Input() column: InternalColumn;

    seats: ImpactPointTypes[];

    get nature(): VehicleNature {
        return this.internalImpactPointService.nature;
    }

    constructor(private internalImpactPointService: InternalImpactPointService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.column && changes.column.previousValue !== changes.column.currentValue) {
            this.seats = this.internalImpactPointService.getSeats(this.nature, this.section, this.column);
        }
    }

}
